import React, { Component } from 'react';
import Header from './components/Header';
import Main from './components/Main';
import './App.css';

class App extends Component {

  render() {
    return (
      <div className="App">
        <Header />
        <Main>
          { this.props.children }
        </Main>
      </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js